import { Dialog } from '@angular/cdk/dialog'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { firstValueFrom } from 'rxjs'

import { MobileHeader, WebSidebar, MobileMenu } from '@layout/components'
import { BadgeAchievedModal } from '@features/sala-de-trofeos/components'
import { SalaDeTrofeosService } from '@features/sala-de-trofeos/data/sala-de-trofeos-service/sala-de-trofeos-service'

@Component({
  selector: 'layout',
  imports: [RouterOutlet, MobileHeader, WebSidebar, MobileMenu],
  templateUrl: './layout.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex md:flex-row h-dvh flex-col overflow-hidden bg-app bg-primary-900'
  }
})
export class Layout {
  #salaDeTrofeosService = inject(SalaDeTrofeosService)
  #dialog = inject(Dialog)

  constructor() {
    this.showUnseenBadges()
  }

  /**
   * Show one achieved-badge modal at a time, waiting for each to close before opening the next.
   * TODO: once notifications exist, merge both sources into a single ordered queue before showing.
   */
  async showUnseenBadges() {
    const badges = await this.#salaDeTrofeosService.getUnseenBadges()

    for (const badge of badges) {
      await firstValueFrom(this.#dialog.open(BadgeAchievedModal, { data: { badge }, disableClose: true }).closed)
    }
  }
}
